import { createRouter, createWebHistory,RouterView } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { getCourseById } from '@/Services/api/CoursesService';
import { getArticleById } from '@/Services/api/ArticlesService';
import { getPostById } from '@/Services/api/PostsService';
//import store from '@/store';
import { useAuthStore } from '@/store/authStore';

const routes = [
  {
    path: '/:locale?', // Define language parameter
    component: RouterView,
    beforeEnter: (to, from, next) => {
      // Define allowed locales
      const allowedLocales = ['ar', 'en'];
      // Redirect to error page if locale is missing or not allowed
      if (!to.params.locale || !allowedLocales.includes(to.params.locale)) {
        next({ path: '/error' });
      } else {
        next();
      }
    },
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView
      },
      {
        path: 'app/ios',
        name: 'ios-app',
        component: () => import(/* webpackChunkName: "ios-app" */ '../views/IosApp.vue')
      },
      {
        path: 'app/android',
        name: 'android-app',
        component: () => import(/* webpackChunkName: "android-app" */ '../views/AndroidApp.vue')
      },
      {
        path: 'join-us',
        name: 'joinus',
        component: () => import(/* webpackChunkName: "joinus" */ '../views/JoinUs.vue')
      },
      {
        path:'order-details/:id/:scheduleId?',
        name: 'order-details',
        component: () => import(/* webpackChunkName: "order-details" */ '../views/OrderDetails.vue'),
        props: true,
      },
      {
        path:'order-approved',
        name: 'order-approved',
        component: () => import(/* webpackChunkName: "order-approved" */ '../views/OrderState.vue'),
      },
      {
        path:'order-canceled',
        name: 'order-canceled',
        component: () => import(/* webpackChunkName: "order-canceled" */ '../views/OrderState.vue'),
      },
      {
        path: 'about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
      },
      {
        path: 'blog',
        name: 'blog',
        component: () => import(/* webpackChunkName: "blog" */ '../views/BlogsView.vue')
      },
      {
        path: 'blog/:id',
        name: 'single-blog',
        component: () => import(/* webpackChunkName: "single-blog" */ '../views/SingleBlogView.vue'),
        props: true,
        // beforeEnter: async (to, from, next) => {
        //   try {
        //     const response = await getArticleById(to.params.id); // Validate ID against your database
        //     if (response.data) {
        //       next(); // Course exists, proceed to the page
        //     } else {
        //       next('/error'); // Redirect to a not-found page if course doesn't exist
        //     }
        //   } catch (error) {
        //     console.error('Error fetching course:', error);
        //     next('/error'); // Handle error (e.g., network issue, invalid ID)
        //   }
        // },
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import(/* webpackChunkName: "contact" */ '../views/ContactView.vue')
      },
      {
        path: 'services',
        name: 'services',
        component: () => import(/* webpackChunkName: "services" */ '../views/ServicesView.vue')
      },
      {
        path: 'courses',
        name: 'courses',
        component: () => import(/* webpackChunkName: "courses" */ '../views/AllCourses.vue')
      },
      {
        path: 'courses/:id',
        name: 'course-details',
        component: () => import(/* webpackChunkName: "course-details" */ '../views/CourseDetails.vue'),
        props: true,
        beforeEnter: async (to, from, next) => {
          try {
            const response = await getCourseById(to.params.id); // Validate ID against your database
            if (response.data) {
              next(); // Course exists, proceed to the page
            } else {
              next('/error'); // Redirect to a not-found page if course doesn't exist
            }
          } catch (error) {
            console.error('Error fetching course:', error);
            next('/error'); // Handle error (e.g., network issue, invalid ID)
          }
        },
      },
      {
        path: 'diplomas',
        name: 'diplomas',
        component: () => import(/* webpackChunkName: "diplomas" */ '../views/DiplomasView.vue')
      },
      {
        path: 'diplomas/:slug',
        name: 'diploma-details',
        component: () => import(/* webpackChunkName: "diploma-details" */ '../views/DiplomaDetails.vue'),
        props: true
      },
      {
        path: 'community',
        name: 'community',
        component: () => import(/* webpackChunkName: "community" */ '../views/Community.vue')
      },
      {
        path: 'community/:id',
        name: 'post',
        component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue'),
        props:true,
        beforeEnter: async (to, from, next) => {
          try {
            const response = await getPostById(to.params.id); // Validate ID against your database
            if (response.data) {
              next(); // Course exists, proceed to the page
            } else {
              next('/error'); // Redirect to a not-found page if course doesn't exist
            }
          } catch (error) {
            console.error('Error fetching course:', error);
            next('/error'); // Handle error (e.g., network issue, invalid ID)
          }
        },
      },
      {
        path: 'partners',
        name: 'partners',
        component: () => import(/* webpackChunkName: "partners" */ '../views/Parteners.vue')
      },
      {
        path: 'reviews',
        name: 'reviews',
        component: () => import(/* webpackChunkName: "reviews" */ '../views/Reviews.vue')
      },
      {
        path: 'clients',
        name: 'clients',
        component: () => import(/* webpackChunkName: "clients" */ '../views/Clients.vue')
      },
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
        beforeEnter: async (to, from, next) => {
          const authStore = useAuthStore();
          if (authStore.getIsAuthenticated) {
            next(''); // Redirect to the homepage or a dashboard if authenticated
          } else {
            next(); // Allow navigation to the login page if not authenticated
          }
        },
      },
      {
        path: 'login-with-2fa',
        name: 'login-with-2fa',
        component: () => import(/* webpackChunkName: "login-with-2fa" */ '../views/LoginWith2FA.vue'),
        beforeEnter: async (to, from, next) => {
          const authStore = useAuthStore();
          if (authStore.getIsAuthenticated) {
            next(''); // Redirect to the homepage or a dashboard if authenticated
          } else {
            next(); // Allow navigation to the login page if not authenticated
          }
        },
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "profile" */ '../views/UserProfile.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'sign-up',
        name: 'sign-up',
        component: () => import(/* webpackChunkName: "sign-up" */ '../views/SignUp.vue'),
        beforeEnter: async (to, from, next) => {
          const authStore = useAuthStore();
          if (authStore.getIsAuthenticated) {
            next(''); // Redirect to the homepage or a dashboard if authenticated
          } else {
            next(); // Allow navigation to the login page if not authenticated
          }
        },
      },
      {
        path: 'external-sign-up',
        name: 'external-sign-up',
        component: () => import(/* webpackChunkName: "external-sign-up" */ '../views/ExternalRegister.vue'),
        beforeEnter: async (to, from, next) => {
          const authStore = useAuthStore();
          if (authStore.getIsAuthenticated) {
            next(''); // Redirect to the homepage or a dashboard if authenticated
          } else {
            next(); // Allow navigation to the login page if not authenticated
          }
        },
      },
      {
        path: 'accounts',
        name: 'accounts',
        component: () => import(/* webpackChunkName: "login-accounts" */ '../views/LoginAccounts.vue'),
        beforeEnter: async (to, from, next) => {
          const authStore = useAuthStore();
          if (authStore.getIsAuthenticated) {
            next(''); // Redirect to the homepage or a dashboard if authenticated
          } else {
            next(); // Allow navigation to the login page if not authenticated
          }
        },
      },
      {
        path: 'forget-pass',
        name: 'forget-pass',
        component: () => import(/* webpackChunkName: "forget-pass" */ '../views/ForgetPass.vue'),
        beforeEnter: async (to, from, next) => {
          const authStore = useAuthStore();
          if (authStore.getIsAuthenticated) {
            next(''); // Redirect to the homepage or a dashboard if authenticated
          } else {
            next(); // Allow navigation to the login page if not authenticated
          }
        },
      },
      {
        path: 'register-otp',
        name: 'register-otp',
        component: () => import(/* webpackChunkName: "register-otp" */ '../views/RegisterOtp.vue'),
        beforeEnter: async (to, from, next) => {
          const authStore = useAuthStore();
          if (authStore.getIsAuthenticated) {
            next(''); // Redirect to the homepage or a dashboard if authenticated
          } else {
            next(); // Allow navigation to the login page if not authenticated
          }
        },
      },
      {
        path: 'faq',
        name: 'faq',
        component: () => import(/* webpackChunkName: "faq" */ '../views/Faq.vue') //test branch
      },
      {
        path: 'support',
        name: 'support',
        component: () => import(/* webpackChunkName: "support" */ '../views/SupportPolicy.vue')
      },
      {
        path: 'complains',
        name: 'complains',
        component: () => import(/* webpackChunkName: "terms" */ '../views/Complains.vue')
      },
      {
        path: 'terms',
        name: 'terms',
        component: () => import(/* webpackChunkName: "terms" */ '../views/Terms.vue')
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: () => import(/* webpackChunkName: "termsPrivacy" */ '../views/TermsPrivacy.vue')
      },
      {
        path: 'learning',
        name: 'learning',
        component: () => import(/* webpackChunkName: "LearningTerms" */ '../views/LearningTerms.vue')
      },
      {
        path: 'terms-conditions',
        name: 'termsconditions',
        component: () => import(/* webpackChunkName: "conditions" */ '../views/Conditions.vue')
      },
        {
            path: 'attendance-policy',
            name: 'attendancepolicy',
            component: () => import(/* webpackChunkName: "conditions" */ '../views/AttendancePolicy.vue')
        },
        {
            path: 'communication-policy',
            name: 'communication-policy',
            component: () => import(/* webpackChunkName: "conditions" */ '../views/CommunicationPolicy.vue')
        },
        {
          path: 'privacy-policy',
          name: 'privacy-policy',
          component: () => import(/* webpackChunkName: "conditions" */ '../views/PrivacyPolicy.vue')
      }
    ],
  },
  {
    path: '/',
    redirect: '/ar'
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../views/ErrorPage.vue')
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/error'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Global router guard to handle authentication initialization
router.beforeEach(async (to, from, next) => {
  window.scrollTo(0, 0);
  
  const authStore = useAuthStore();
  
  // Wait for authentication check to complete if it's still in progress
  await authStore.waitForAuthCheck();
  
  next();
});

export default router